"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cleanSlug = cleanSlug;
exports.getTemplatePath = getTemplatePath;
function cleanSlug(slug) {
  if (!slug) {
    return null;
  }
  return slug.replace(/^\/+|\/+$/g, '');
}
function getTemplatePath(templateName) {
  return "./templates/".concat(templateName, "/Template.jsx");
}